{
  "fr": {
    "button": {
      "actions": {
        "add": "Ajouter",
        "cancel": "Annuler",
        "close": "Fermer",
        "copyEmail": "Copier l'adresse email",
        "create": "Ajouter",
        "delete": "Supprimer",
        "display": "Afficher",
        "edit": "Modifier",
        "hide": "Cacher",
        "loading": "Est en cours de chargement",
        "move": "Déplacer",
        "move_down": "Déplacer vers le bas",
        "move_up": "Déplacer vers le haut",
        "no": "Non",
        "reactivateEmailAddress": "Réactiver l'adresse e-mail",
        "reset": "Réinitialiser",
        "save": "Sauvegarder",
        "save_changes": "Enregistrer les modifications",
        "save_message": "Sauvegarder message",
        "saving": "Sauvegarde est en cours",
        "share": "Partager",
        "startTour": "Commencer la tournée",
        "uploadingDocuments": "Téléchargement de documents",
        "yes": "Oui"
      }
    }
  }
}
